import api from "@/services/api"
export default {
    methods: {
        async getDomain () {
            try {

                this.filter = Object.assign(this.filter, {
                    idCompany: this.companyId,
                });
                delete this.filter['startDate']
                delete this.filter['endDate']
                const { data } = await api.getDomainLoki(this.filter);
                if(!data.content) return
                this.acordeon.forEach((el) => {
                    if (el.origin === "domain") {
                        el.table["items"] = data
                        el.table["items"].content = data.content.map((mp) => {
                            return {
                                ...mp,
                                status: this.getStatusName(mp.status),
                                route: "domain",
                                buttons: ['save','edit','remove']

                            };
                        });
                        el.table['rows'] = data.totalElements;
                    }
                });
            } catch (error) {
                this.errorCatch(error);
            } 
        },
        async createDomain (payload) {
            try {
                this.$store.commit("utils/setLoading", true);
                delete payload["id"];
                delete payload["origin"];
                payload["clientid"] = parseInt(payload["clientid"]);
                payload["status"] = payload["status"] === "Ativo" ? 'enable' : 'disable';
                await api.setDomainLoki(payload);
                this.getDomain();
            } catch (error) {
                this.errorCatch(error);
            } finally {
                this.$store.commit("utils/setLoading", false);
                this.$bvModal.hide("domain");
            }
        },

        async updateDomain (payload) {
            try {
                this.$store.commit("utils/setLoading", true);
                payload["clientid"] = parseInt(payload["clientid"]);
                const obj = {
                    clientid: payload["clientid"],
                    status: payload["status"],
                };
                await api.updateDomainLoki(obj, payload["id"]);
                this.reset("domain");
            } catch (error) {
                this.errorCatch(error);
            } finally {
                this.$store.commit("utils/setLoading", false);
                this.$bvModal.hide("domain");
            }
        },
        async removeDomain (payload) {
            try {
                this.$store.commit("utils/setLoading", true);
                await api.removeDomainLoki(payload);
                this.reset("domain");
            } catch (error) {
                this.errorCatch(error);
            } finally {
                this.$store.commit("utils/setLoading", false);
                this.$bvModal.hide("domain");
            }
        },
    }
}